import { parseZone } from 'moment';

export const formatDeliveryDate = (dateString) => {
  if (!dateString) return '';
  return parseZone(dateString).format('ddd, MMM D');
};
